import { format } from "date-fns";
import { enGB } from "date-fns/locale";

export function formatDateTime(date?: Date | null | undefined): string {
  if (!date) return "";

  return format(date, "yyyy-MM-dd HH:mm", { locale: enGB });
}
